import React from "react";
import useGetDynamicConfigManager from "../dynamic-config/hooks/useGetDynamicConfigManager";
import { buildMailTo } from "../utils/email";
import { EmailLinkProps, ExternalLink } from "./ExternalLink";
import { supportEmail } from "./urls";

export const ManagerEmailSupportLink = (props: EmailLinkProps) => {
  const manager = useGetDynamicConfigManager();
  const email = manager?.supportEmail || supportEmail;

  return <ExternalLink href={buildMailTo(email)} label={email} {...props} />;
};
